import React from "react"
import {
  DialogTitle as MuiDialogTitle,
  IconButton,
  useTheme,
  Box,
  Typography,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

/**
 * DialogTitle with close button.
 */
const DialogTitle = ({ children, onClose = null, ...props }) => {
  const theme = useTheme()

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={theme.spacing(2)}
    >
      <Typography variant="h6" noWrap {...props}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          color={theme.palette.grey[500]}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </Box>
  )
}

export default DialogTitle
